export function initRiderSearch(component, getRiders) {
    window.addEventListener('rider-search', async ({ detail }) => {
        const q = (detail?.q ?? '').trim().toLowerCase();
        if (!q) return;

        const match = getRiders().find(r =>
            r.name.toLowerCase().includes(q) && r.category === component.activeTab
        );
        if (!match) {
            window.dispatchEvent(new CustomEvent('rider-search-noresult'));
            return;
        }

        await new Promise(r => requestAnimationFrame(r));

        const el = document.getElementById(match.id);
        if (el) {
            // window.scrollTo is more reliable than scrollIntoView({behavior:'smooth'})
            // on iOS Safari (which often no-ops with sticky headers / momentum scroll)
            const top = el.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 2;
            window.scrollTo({ top, behavior: 'smooth' });
            el.style.background = 'rgba(234,179,8,0.15)';
            setTimeout(() => el.style.background = '', 2000);
        }
    });
}

export function riderId(name) {
    return 'heat-rider-' + name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}
